// extracted by mini-css-extract-plugin
export default {"container":"CreateLottery_container__K+7mI","header":"CreateLottery_header__s7or-","form-container":"CreateLottery_form-container__5I1Ky"};